import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=4faf7d1d&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=4faf7d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf7d1d",
  null
  
)

export default component.exports